import { createGlobalState, useMediaQuery } from '@vueuse/core';

export const useResponsiveLayout = createGlobalState(() => {
    const isMd = useMediaQuery('(min-width: 48rem)');
    const isLg = useMediaQuery('(min-width: 64rem)');
    const isMdShortHeight = useMediaQuery('(min-width: 48rem) and (max-height: 56rem)');

    return {
        isMd,
        isLg,
        isMdShortHeight,
    };
});
